<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="row m-0 align-items-center w-100 justify-content-center">
        <div class="modal-container col-11 col-md-9 col-lg-7 p-0">
          <div class="modal-header">
            <h5 class="modal-title" id="quote_modal_title">{{myItem.title}}</h5>
            <button type="button" class="close" @click="$emit('close', false)"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body" v-if="uploading">
            <grid-loader :loading="uploading" :color="loaderColor" :size="loaderSize"></grid-loader>
          </div>
          <div class="modal-body" v-else>
            <div class="row">
              <div class="col-4 pointer" v-for="(img, index) in gallery" :key="img.url" @click="selectImage(img.url)">
                <div class="cross_icon">
                  <div class="row m-0">
                    <div class="col-auto px-2 py-1 text-center">
                      <span class="material-icons" @click.stop="removeImg(img, index)">
                        close
                      </span>
                    </div>
                  </div>
                </div>
                <img :src="img.url" alt="" class="img-fluid img" :class="{'selected': myImages.includes(img.url)}" v-if="multiple">
                <img :src="img.url" alt="" class="img-fluid img" :class="{'selected': img.url === myItem.thumbnail_url}" v-else>
              </div>
            </div>
            <div class="row border-top-black">
              <div class="col-12">
                <vue-upload-multiple-image
                  dragText="Drop multiple files here"
                  browseText="or click to select"
                  dropText="Drop your file here..."
                  markIsPrimaryText=""
                  popupText=""
                  primaryText=""
                  :showPrimary="false"
                  :data-images="images"
                  idUpload="myIdUpload"
                  editUpload="myIdEdit"
                  @upload-success="uploadImageSuccess"
                  :maxImage=50
                >
                </vue-upload-multiple-image>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary font14" @click="$emit('close')">{{btnN}}</button>
            <button type="button" class="btn btn-primary font14" @click="$emit('save', myImages)" v-if="multiple">{{btnY}}</button>
            <button type="button" class="btn btn-primary font14" @click="$emit('save', myItem)" v-else>{{btnY}}</button>
          </div>
        </div>
      </div>
      <div class="remove_alert" v-if="isDeleteAlert != null">
        <div class="row m-0 align-items-center w-100 justify-content-center h-100">
          <div class="modal-container col-11 col-md-9 col-lg-7 p-0">
            <div class="modal-header">
              <h5 class="modal-title">Are you sure you want to remove this image?</h5>
              <button type="button" class="close" @click="isDeleteAlert = null"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary font14" @click="isDeleteAlert = null">Close</button>
              <button type="button" class="btn btn-primary font14" @click="deleteImg(isDeleteAlert)">Remove</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    'vue-upload-multiple-image': () => import('vue-upload-multiple-image'),
    GridLoader: () => import('vue-spinner/src/MoonLoader.vue')
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    btnN: {
      type: String,
      default: 'Cancel'
    },
    btnY: {
      type: String,
      default: 'Confirm'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loaderColor: '#5cb85c',
      loaderSize: '50px',
      images: [],
      myImages: [],
      myItem: null,
      uploading: false,
      isDeleteAlert: null
    }
  },
  computed: {
    ...mapGetters(['gallery'])
  },
  created () {
    this.myItem = { ...this.item, thumbnail_url: this.item.thumbnail_url || null }
    this.myImages = this.item.images || []
    this.getProductGallery()
  },
  methods: {
    ...mapActions(['addProductImage', 'getProductGallery', 'updateGallery']),
    async uploadImageSuccess (formData, index, fileList) {
      this.uploading = true
      for (const f of fileList) {
        await this.addProductImage(f)
        this.myItem.thumbnail_url = this.gallery[this.gallery.length - 1].url
      }
      this.uploading = false
    },
    removeImg (img, index) {
      this.isDeleteAlert = index
    },
    selectImage (url) {
      if (this.multiple) {
        if (this.myImages.includes(url)) {
          this.myImages = this.myImages.filter((item) => {
            return item !== url
          })
        } else {
          this.myImages.push(url)
        }
      } else {
        this.myItem.thumbnail_url = url
      }
    },
    deleteImg (index) {
      this.gallery.splice(index, 1)
      this.updateGallery(this.gallery)
      this.isDeleteAlert = null
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  background-color: var(--light-color);
  transition: all .3s ease;
  overflow-y: auto;
  max-height: 98vh;
}
.dark-mode .modal-container {
  background-color: var(--dark-color-off);
  transition: all .3s ease;
  overflow-y: auto;
  max-height: 98vh;
}
.dark-mode .modal-header .close {
  color: var(--light-color);
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
}
.img {
  border: 8px solid transparent;
  opacity: 0.5;
}
.selected {
  border: 5px solid var(--dark-color);
  opacity: 1;
}
.dark-mode .selected {
  border: 5px solid var(--light-color);
}

.border-top-black {
  border-top: 3px solid darkgray;
  padding-top: 1rem;
  margin-top: 3rem;
}
.img-event {
  width: 20%;
  float: left;
  padding: 0 !important;
  margin: 0;
  height: auto;
}
.cross_icon {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  top: 0;
  right: 0;
  z-index: 2;
  color: var(--dark-color);
  background-color: var(--light-color);
}
.cross_icon_small {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  top: 0;
  z-index: 2;
  color: var(--dark-color);
  background-color: var(--light-color-07);
  left: 0;
}
.cross_icon .material-icons {
  font-size: 0.7rem;
}
.cross_icon_small .material-icons {
  font-size: 0.5rem;
}
.dark-mode .cross_icon {
  background-color: var(--dark-color-off);
  color: var(--light-color);
}
.dark-mode .cross_icon_small {
  background-color: var(--dark-color-off);
  color: var(--light-color);
}
.remove_alert {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9;
  background-color: var(--dark-color-07);
}
</style>
